export const CAPI_GALLERY_IMAGE_RELS = [
  'exterior-front',
  'exterior-side',
  'exterior-rear',
  'exterior-rear-centre',
  'exterior-rear-right',
  'exterior-side-right',
  'exterior-front-left-zoomed',
  'interior-front',
  'interior-side',
  'interior-side-rear-right',
  'exterior-top-left',
  'exterior-rear-boot',
];

export const CAPI_EXTERIOR_360_IMAGE_RELS = [
  'exterior-360-1',
  'exterior-360-2',
  'exterior-360-3',
  'exterior-360-4',
  'exterior-360-5',
  'exterior-360-6',
  'exterior-360-7',
  'exterior-360-8',
  'exterior-360-9',
  'exterior-360-10',
  'exterior-360-11',
  'exterior-360-12',
];

export const CAPI_INTERIOR_360_IMAGE_REL = 'interior-360';

export const CAPI_PREVIEW_IMAGE_REL = 'exterior-side';

export const ALL_CAPI_IMAGE_RELS = [
  ...CAPI_GALLERY_IMAGE_RELS,
  ...CAPI_EXTERIOR_360_IMAGE_RELS,
  CAPI_INTERIOR_360_IMAGE_REL,
] as const;

export type CapiImageRels = (typeof ALL_CAPI_IMAGE_RELS)[number];

export const URL_GREYED_OUT_CAR =
  'https://assets.volkswagen.com/is/image/volkswagenag/greyed-out-car?Zml0PWNyb3AlMkMxJndpZD04NDQmaGVpPTQ3NCZmbXQ9cG5nLWFscGhhJmJmYz1vZmYmMjZkYg==';
